import { useMemo } from "react"
//check if the current user is go to team
const useIsGTT = position => {
  return useMemo(
    () => {
      return (position && position.user_company === "Go To Team") || false
    },
    [position]
  )
}

export default useIsGTT
